const locale = require('./createSubmission.i18n.json');

/*@ngInject*/
const CreateSubmissionModalController = function ($rootScope, $scope, $stateParams, $timeout, coreMediator, submissionId, formId, coreConstant, submissionConstant,
                                                  submissionTransition, currentSubmissionModel, submissionMediator, submissionAction, submissionStateMediator,
                                                  wizardMediator, wizardActionUtil, wizardActionHandlerUtil, formViewerConstant, browserUtil) {

    const originalFormId = formId;
    const timeoutList = [];

    $scope.i18n = locale;

    $scope.submissionId = submissionId;
    $scope.formId = originalFormId;
    $scope.isPrequalificationLoading = false;

    $scope.actions = [];
    $scope.context = {
        identifier: 'submission',
        actions: {},
        fallthrough: submissionConstant.CONTEXT_SUBMISSION,
        model: wizardMediator.getContext()
    };

    $scope.$on(formViewerConstant.event.FORM_LAZY_RENDERING_END, function () {
        if (browserUtil.isIE11() || browserUtil.isEdge()) {
            $timeout(function () {
                $('.modal-content').width($('.formViewerContainer')[0].offsetWidth + 100);
            }, 500);
        }
    });

    $scope.$on(formViewerConstant.event.SUPPLEMENTAL_FORM_ADDED, function () {
        timeoutList.push($timeout(function () {
            $rootScope.$broadcast(formViewerConstant.event.OPTIMIZE_FORM_WATCHERS);
        }, 500));
    });

    function loadActions() {
        const actionIds = wizardActionUtil.getActionIds($scope.context.model.hierarchicalContextList);

        function loadActionsInternal() {
            wizardActionUtil.resetActions();

            wizardActionUtil.getAllActions(actionIds).then(function (allActions) {
                $scope.actions = allActions;
                $scope.actionsTimeLastModified = new Date().getTime();
            });
        }

        if (!_.isNil(currentSubmissionModel.getCurrentNewSubmission())) {
            loadActionsInternal();
        } else {
            submissionMediator.clearCurrentActionRegistrations().finally(function () {
                loadActionsInternal();
            });
        }
    }

    $scope.onClose = function () {
        let action = null;
        _.each($scope.actions, function (subAction) {
            action = _.find(subAction.actions, {name: submissionAction.DELETE_PRE_DRAFT});
            if (!_.isNil(action)) {
                return false;
            }
        });

        if (!_.isNil(action)) {
            $scope.handleAction(action);
        }
    };

    $scope.isConfirmButtonDisabled = function () {
        return false;
    };

    $scope.$on('$stateChangeStart', function () {
        $scope.$close();
        currentSubmissionModel.setCurrentNewSubmission(null);
    });

    $scope.$on(coreConstant.event.CLOSE_SUBMISSION_VIEW, function (event, submissionId) {
        if (submissionId === $scope.submissionId) {
            $scope.$dismiss();
            currentSubmissionModel.setCurrentNewSubmission(null);
        }
    });

    $scope.$on(coreConstant.event.START_MAKING_APPLICATION, function () {
        $scope.$close();
        currentSubmissionModel.setCurrentNewSubmission(null);
    });

    $scope.$on(submissionConstant.event.PREQUALIFICATION_STOP_LOADING, function () {
        $scope.isPrequalificationLoading = false;
    });

    $scope.$on(submissionConstant.event.PREQUALIFICATION_START_LOADING, function () {
        $scope.isPrequalificationLoading = true;
    });

    $scope.$on(submissionConstant.event.PREQUALIFICATION_CHANGE_FORM_ID, function (event, submission) {
        const newSubmission = submissionStateMediator.getNewSubmissionState();

        $scope.formId = submission.formId;

        newSubmission.formId = $scope.formId;

        submissionStateMediator.saveNewSubmissionState(newSubmission);
    });

    $scope.handleAction = function (action, file) {
        wizardActionHandlerUtil.handleAction(action, file);
    };

    $scope.$on(coreConstant.event.UPDATE_ACTIONS_MESSAGE, function (event, updateActionsMessage, entityType, entityId) {
        let contextActions;

        if (entityType === 'submission' && parseInt($scope.submissionId) === entityId) {
            contextActions = _.find($scope.actions, {'contextType': submissionConstant.CONTEXT_SUBMISSION});
            if (contextActions) {
                contextActions.actions = updateActionsMessage.actions.actions;
            }

            $scope.actionsTimeLastModified = new Date().getTime();
            timeoutList.push($timeout(function () {}, 0));
        }
    });

    $scope.$on(coreConstant.event.RELOAD_ACTIONS, function () {
        submissionMediator.clearCurrentActionRegistrations().finally(function () {
            loadActions();
        });
    });

    $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
        $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
    });

    $scope.$on('$destroy', function () {
        _.each(timeoutList, function (timeout) {
            $timeout.cancel(timeout);
        });
    });

    $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);

    submissionMediator.loadSubmission(submissionId).then(function (submission) {
        currentSubmissionModel.setCurrentNewSubmission(submission);
        $scope.currencyCode = currentSubmissionModel.getCurrentNewSubmission().currencyCode;
    });

    loadActions();
};

angular.module('gw-um-submission')
    .controller('createSubmissionModalController', CreateSubmissionModalController);
